import classNames from 'classnames';
import { FC } from 'react';

import { IcStreaming16Icon } from '@gem/icons';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import styles from './JoinStreamingButton.styles.m.css';

interface IJoinStreamingButtonProps {
  className?: string;
  isActive?: boolean;
  onClick?(): void;
}

export const JoinStreamingButton: FC<IJoinStreamingButtonProps> = ({
  className,
  isActive,
  onClick,
}) => {
  return (
    <button
      className={classNames(styles.button, className, {
        [styles.canPress]: !!onClick,
      })}
      type="button"
      disabled={isActive}
      onClick={onClick}
    >
      <IconView
        className={styles.icon}
        Icon={IcStreaming16Icon}
        size={IconViewSizes.Small}
      />
      <span className={styles.label}>LIVE</span>
    </button>
  );
};
